import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import React, { useContext } from 'react';
import AuthContext from '@cpg-its/ads.auth.auth-context';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router';
import { useBasePath } from '../../../../../../global/hooks/useBasePath';
import { useQuery } from '../../../../../../global/hooks/useQuery';
import { DemographicAppKeys } from '../../../../../../global/models/demographics-model';
import { Institution } from '../../../../../../global/models/institution-model';
import { Person } from '../../../../../../global/models/person-model';
import { TcsmEpiApiState, TcsmStates } from '../../../../../../root/tcsm-model';
import { useDemographicsPerson } from '../../../../../account-info/hooks/useDemographicsPerson';
import { ArcRoutes } from '../../../../constants/routes';
import { InstitutionState } from '../../institution-model';
import { usePlanSummary } from '../../plan-summary/usePlanSummary';
import PlanAdoptionStepper from '../display-components/plan-adoption-stepper';
import { GetPlanAdoptionWizard } from '../factory/plan-adoption-wizard-factory';
import { PlanAdoptionFormTypes } from '../models/plan-adoption-form-models';
import { PlanAdoptionRoutes } from '../routes';
import QccoAdoptionDetailsForm from './qcco-adoption-details-form';
import QccoIndemnifyForm from './qcco-indemnify-form';
import QccoQuestionsForm from './qcco-questions-form';
import QccoReview from './qcco-review';


function QccoPlanAdoption() {
	const routeMatch = useRouteMatch();
	const formType = useQuery().get('formType')?.toLowerCase() as PlanAdoptionFormTypes;
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	const { accessToken, decodedToken } = useContext(AuthContext) as any;

	const institutionState = useSelector<TcsmStates, InstitutionState>(state => state.institutionState);
	const summaryPlanLoaded = usePlanSummary(institutionState?.institutionClientNumber);
	const planSummary = institutionState?.planSummary;

	const epiContent = useSelector<TcsmStates, TcsmEpiApiState>(state => state?.epiProps);
	const onSuccessUrl = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}${ArcRoutes.PlanSummary}`);
	const institutionRootPath = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}`);
	const featureRootPath = routeMatch?.path;

	const personLoaded = useDemographicsPerson(DemographicAppKeys.myCPG);
	const person = useSelector<TcsmStates, Person>(state => state?.personalInfo[DemographicAppKeys.myCPG].currentPerson);
	const currentInstitution = useSelector<TcsmStates, Institution>(state => state?.institutionState?.currentInstitution);

	const wizard: any = GetPlanAdoptionWizard({ formType, dispatch, history, epiContent, onSuccessUrl, location, featureRootPath, institutionRootPath, person, currentInstitution, planSummary, authToken: accessToken, loginTime: decodedToken?.iat });

	const isIndemnificationRequired = wizard?.isIndemnificationRequired();

	if (!summaryPlanLoaded || !personLoaded) {
		return <LoadingCircle />;
	}

	if (!wizard) {
		return <Redirect to={institutionRootPath} />;
	}

	return <>

		<PlanAdoptionStepper wizard={wizard} institution={currentInstitution} />
		<Switch>
			<Route exact path={`${routeMatch.path}${PlanAdoptionRoutes.QccoQuestions}`}>
				<QccoQuestionsForm wizard={wizard} />
			</Route>

			<Route exact path={`${routeMatch.path}${PlanAdoptionRoutes.AdoptionDetails}`}>
				<QccoAdoptionDetailsForm wizard={wizard} />
			</Route>

			<Route exact path={`${routeMatch.path}${PlanAdoptionRoutes.Review}`}>
				<QccoReview wizard={wizard} />
			</Route>

			<Route exact path={`${routeMatch.path}${PlanAdoptionRoutes.Indemnify}`}>
				<QccoIndemnifyForm wizard={wizard} />
			</Route>

			<Route exact path={`${routeMatch.path}`}>
				{
					isIndemnificationRequired &&
					<Redirect to={`${routeMatch.path}${PlanAdoptionRoutes.Indemnify}${location.search}`} />
				}

				{
					!isIndemnificationRequired &&
					<Redirect to={`${routeMatch.path}${PlanAdoptionRoutes.QccoQuestions}${location.search}`} />
				}
			</Route>
		</Switch>
	</>;

}

export default QccoPlanAdoption;